var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriendlyMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.086,
    height: 7.354,
    viewBox: "0 0 6.086 7.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "friendship",
    transform: "translate(-24 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83759",
    "data-name": "Path 83759",
    d: "M29.325,60H24.761a.762.762,0,0,0-.761.761v1.521a.508.508,0,0,0,.507.507v1.775a.508.508,0,0,0,.507.507h1.014a.508.508,0,0,0,.507-.507V61.521h-.507v3.043H25.014V62.282h-.507V60.761a.254.254,0,0,1,.254-.254h4.564a.254.254,0,0,1,.254.254v1.521h-.507v2.282H28.057V61.521H27.55v3.043a.508.508,0,0,0,.507.507h1.014a.508.508,0,0,0,.507-.507V62.789a.508.508,0,0,0,.507-.507V60.761A.762.762,0,0,0,29.325,60Z",
    transform: "translate(0 -51.718)",
    fill: "#ffb100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83760",
    "data-name": "Path 83760",
    d: "M37.014,8.029a1.014,1.014,0,1,1,1.014-1.014A1.014,1.014,0,0,1,37.014,8.029Zm0-1.521a.507.507,0,1,0,.507.507A.507.507,0,0,0,37.014,6.507Z",
    transform: "translate(-11.493 0)",
    fill: "#ffb100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83761",
    "data-name": "Path 83761",
    d: "M109.014,8.029a1.014,1.014,0,1,1,1.014-1.014A1.014,1.014,0,0,1,109.014,8.029Zm0-1.521a.507.507,0,1,0,.507.507A.507.507,0,0,0,109.014,6.507Z",
    transform: "translate(-80.45 0)",
    fill: "#ffb100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendlyMessageIcon);
export default __webpack_public_path__ + "static/media/friendly-message-icon.f382bca58794a8bcf396c65bbcb98c4a.svg";
export { ForwardRef as ReactComponent };